import { render } from "./_WhatWeDo.vue?vue&type=template&id=127d952f&scoped=true&lang=en"
import script from "./_WhatWeDo.vue?vue&type=script&lang=js"
export * from "./_WhatWeDo.vue?vue&type=script&lang=js"

import "./_WhatWeDo.vue?vue&type=style&index=0&id=127d952f&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127d952f"]])

export default __exports__